/**
 * User-facing display name for the in-app AI assistant. Centralised here so
 * the brand can be renamed in a single place.
 *
 * Scope is the visible label only — internal identifiers (component names, the
 * `otto/` directory, the `canAskOtto` permission key) intentionally keep their
 * original names and are not affected by changing this value.
 */
export const ASSISTANT_NAME = 'Lift AI';

/**
 * What the header action calls itself. Says what the control is rather than asking the
 * reader to phrase a request ("Ask …"), and carries no beta mark — the assistant is
 * part of the product now, and the badge was competing with the label beside it.
 */
export const ASSISTANT_BUTTON_LABEL = `${ASSISTANT_NAME} Assistant`;
